module.exports = __webpack_public_path__ + "img/koen.83d2c2dd.jpg";